@if (!message.templateLost) {
  <div
    class="poster"
    [style.background-image]="
      'url(' + (message.content.content | imageType) + ')'
    "
    [style.height.px]="height$ | async"
    [matTooltip]="message.content.alt"
    [matContextMenu]="contextMenu"
    [matContextMenuDisable]="mode === 'READ'"
    [attr.data-testid]="'poster-container'"
    [class.error]="hasError"
    #poster
  >
    @if (scale$ | async; as scale) {
      @for (area of message.content.areas; track area) {
        <div
          class="area"
          [class.active]="area.isSelected"
          [style.top.px]="area.y * scale"
          [style.left.px]="area.x * scale"
          [style.width.px]="area.width * scale"
          [style.height.px]="area.height * scale"
          [matTooltip]="tooltip"
          [attr.data-testid]="'poster-area'"
        >
          <ng-template #tooltip>
            @switch (area.type) {
              @case ('share-message') {
                {{ area.type | areaType }} :
                {{ area['shareMessageName'] }}
              }
              @case ('add-friend') {
                {{ area.type | areaType }}
              }
              @case ('share-add-friend') {
                {{ area.type | areaType }} :
                {{ area['shareMessageName'] }}
              }
              @default {
                {{ area.type | areaType }} :
                {{ area['content'] }}
              }
            }
          </ng-template>
        </div>
      }
    }
    @if (hasShareAction()) {
      @for (area of message.content.areas; track area) {
        <ms-share-preview
          class="absolute right-0 top-1/2 -translate-y-1/2"
          [messageId]="area['messageId']"
          [shareCurrentMessage]="area['shareCurrentMessage']"
          [package]="package"
        ></ms-share-preview>
      }
    }
  </div>
} @else {
  <div
    class="mat-elevation-z2 template-lost"
    i18n
    [attr.data-testid]="'template-lost-msg'"
  >
    <mat-icon class="mat-18">search_off</mat-icon><br />
    圖像編輯器中的海報已被刪除<br />無法預覽
  </div>
}
@if (hasError) {
  <div class="flex items-center justify-end py-2">
    <mat-icon class="text-red-500 mr-2 !h-[24px]">error</mat-icon>
    必填欄位資料有誤
  </div>
}

<mat-menu #contextMenu class="tiny-menu">
  <button
    mat-menu-item
    (click)="editPoster()"
    i18n
    [attr.data-testid]="'edit-poster-btn'"
  >
    <mat-icon>settings</mat-icon>編輯海報細節
  </button>

  @if (!message.template) {
    <button
      mat-menu-item
      (click)="editAlt(elementRef)"
      element-ref
      #elementRef="elementRef"
      i18n
      [attr.data-testid]="'edit-alt-text-btn'"
    >
      <mat-icon>title</mat-icon>編輯替代文字
    </button>
  }

  <mat-divider> </mat-divider>

  <button
    mat-menu-item
    (click)="delete()"
    i18n
    [attr.data-testid]="'delete-poster-btn'"
  >
    <mat-icon>delete</mat-icon> 刪除
  </button>

  <button
    mat-menu-item
    (click)="swapUpward()"
    [disabled]="isFirstMessage"
    i18n
    [attr.data-testid]="'move-up-btn'"
  >
    <mat-icon>arrow_upward</mat-icon> 上移
  </button>

  <button
    mat-menu-item
    (click)="swapDownward()"
    [disabled]="isLastMessage"
    i18n
    [attr.data-testid]="'move-down-btn'"
  >
    <mat-icon>arrow_downward</mat-icon> 下移
  </button>
</mat-menu>
